import { render, staticRenderFns } from "./DialogConfirmar.vue?vue&type=template&id=5a37dd53"
import script from "./DialogConfirmar.vue?vue&type=script&lang=js"
export * from "./DialogConfirmar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports